import React, {useRef, useState, useEffect} from 'react'
import {
    Checkbox,
    Fab,
    Icon,
    Typography,
    LinearProgress,
    useMediaQuery
} from '@material-ui/core';
import classNames from 'classnames'
import GoogleMapReact from 'google-map-react';
import { useIntl } from 'src/common/razzle-platform-translate'
import MapMarker from 'src/common/razzle-platform-map/components/MapMarker'
import { useMobileDetector } from 'src/common/razzle-platform-components/hooks/mobile-detector'
import {GOOGLE_MAP_API_KEY, HEIGHT} from 'src/common/razzle-platform-map/configs'
import { useSelector } from 'react-redux'



function GoogleMap(props) {
    const googleMapRef = useRef(null)
    const [askToSearch, setAskToSearch] = useState(false)
    const [searchOnChange, setSearchOnChange] = useState(true)
    const { formatMessage } = useIntl()
    const { isMobile } = useMobileDetector()
    const matches = useMediaQuery('(max-width: 1100px)')
    const firstLoad = useRef(true)
    const {items, visible, center, zoom, hoveredElement, handleOnMarkerHover, itemRoutes,
        handleOnMarkerLeave, filters, setFilter, applyFilter, cancelFilter, getMapSize, handleGeoCoder, pagination,
        toggleMap, handleFilterDialog, markerPreviwItem, marker, updateInProgress, setIsFilteringByCountry, isFilteringByCountry
    } = props
    const locale = useSelector((state) => state.translationModel.locale)
    useEffect(() => {
        getMapSize(googleMapRef.current.clientHeight, googleMapRef.current.clientWidth)
        googleMapRef.current.scrollIntoView()
	}, [])


    const height = isMobile ? HEIGHT.mobile : ''


    const toggleSearchOnChange = () => {
        setSearchOnChange(!searchOnChange)
    }

    const resumeSearchOnChange = () => {
        setAskToSearch(false)
        applyFilter()
    }

    // we didn't apply filter directly from setFilter
    // because we want the last changes to be saved
    useEffect(() => {
        if (searchOnChange && filters.marginBounds) applyFilter()
    }, [filters.marginBounds])

    const handleChange = (bounds) => {
        // handleChange is called twice when the component first loads 
        // in the first load we want it to do nothing 
        // (unless there's no marginBounds and no inCenter)
        // because we want to keep the last changes, until the user moves inside the map
        if ((!filters.marginBounds && !filters.inCenter) || !firstLoad.current) {
            setFilter({marginBounds: `[${bounds.sw.lat},${bounds.sw.lng},${bounds.ne.lat},${bounds.ne.lng}]`, inCenter: undefined, 'address.countryCode': isFilteringByCountry ? filters['address.countryCode'] : undefined})
            if (isFilteringByCountry) {
                setIsFilteringByCountry(false)
            }
        }
        if (firstLoad.current) {
            if (firstLoad.current === "wait") firstLoad.current = false
            else firstLoad.current = "wait"
        }
        if (!searchOnChange) {
            setAskToSearch(true)
        }
    }

    return (
        <div ref={googleMapRef} style={{ height: height, width: '100%' }} className={classNames(!visible ? 'hidden h-0' : '', 'relative')}>
            {updateInProgress && <LinearProgress className="relative" color="secondary" style={{height: 3}} />}
            <div style={{ height: '100%', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: `${GOOGLE_MAP_API_KEY}&language=${locale}`, language: locale }}
                    hoverDistance={40}
                    center={center}
                    zoom={zoom}
                    // onDrag={() => checkOnDrag()}
                    onChildMouseEnter={(key, {item}) => handleOnMarkerHover(item)}
                    onChildMouseLeave={() => handleOnMarkerLeave()}
                    onChange={(map) => handleChange(map.bounds, map.center)}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={api => handleGeoCoder(api.maps.Geocoder)}
                    // These option were added to show map landmarks (schools, hospitals, ...)
                    options={{
                        styles: [{
                            stylers: [{
                                visibility: 'on'
                            }]
                        }],
                        gestureHandling: 'greedy'
                    }}
                >
                    {items.map((item, index) => {
                        return (
                            <MapMarker
                                key={index}
                                lat={item.address.latitude}
                                lng={item.address.longitude}
                                isHovered={hoveredElement === item.id}
                                item={item}
                                markerPreviwItem={markerPreviwItem}
                                marker={marker}
                                itemRoutes={itemRoutes}
                            />
                    )})}
                </GoogleMapReact>
                {!isMobile && !matches && <Fab
                    size="medium"
                    variant="extended"
                    className="bg-white text-base hover:bg-white focus:bg-white"
                    onClick={toggleMap}
                    style={{
                        top: '10px',
                        left: '10px',
                        position: "absolute",
                        borderRadius: '1rem',
                        padding: 0
                    }}
                >
                    <Icon style={{ width: '18px', fontSize: '18px' }}>arrow_forward_ios</Icon>   
                </Fab>}
                {!isMobile && <Fab
                        size="medium"
                        variant="extended"
                        className="bg-white text-base hover:bg-white focus:bg-white"
                        onClick={!askToSearch ? toggleSearchOnChange : resumeSearchOnChange}
                        style={{
                            top: '10px',
                            left: isMobile ? '6.5rem' : matches ? '10px' : '60px',
                            margin: 0,
                            position: 'absolute',
                            borderRadius: '1rem',
                            width: '77%',
                            maxWidth: 'fit-content'
                        }}
                    >
                        {!askToSearch ?
                            <>
                                <Checkbox
                                    icon={<Icon className="text-base">check_box_outline_blank</Icon>}
                                    checkedIcon={<Icon className="text-base">check_box</Icon>}
                                    checked={searchOnChange}
                                />
                                <Typography variant="overline" className="truncate">{formatMessage({
                                    id: 'Actualiser la recherche quand je déplace la carte',
                                    defaultMessage: 'Actualiser la recherche quand je déplace la carte'
                                    })}
                                </Typography>
                            </> :
                            <>
                                <Icon className="text-xl mx-2">refresh</Icon>
                                <Typography variant="overline">{formatMessage({ id: 'Actualiser la recherche', defaultMessage: 'Actualiser la recherche' })}</Typography>
                            </>
                        }
                    </Fab>
                }

                {isMobile && <Fab
                    size="medium"
                    variant="extended"
                    className="bg-white text-base hover:bg-white focus:bg-white"
                    onClick={toggleMap}
                    style={{
                        top: '1px',
                        left: '1rem',
                        margin: 0,
                        position: "absolute",
                        marginTop: '1rem',
                        paddingLeft: '.75rem',
                        paddingRight: '.75rem',
                        borderRadius: '1rem',
                    }}
                >
                    <Typography variant="overline" className="text-sm mr-1">{formatMessage({ id: 'List', defaultMessage: 'List'})}</Typography>
                    <Icon className="text-xl"> reorder </Icon>
                </Fab>}

                {isMobile && <Fab
                    onClick={handleFilterDialog}
                    className="text-white"
                    color="primary"
                    size="medium"
                    variant="extended"
                    style={{
                        bottom: !isMobile ? '20px' : '',
                        left: !isMobile ? '1rem' : '6.5rem',
                        top: isMobile ? '1px' : '',
                        margin: 0,
                        position: "absolute",
                        marginTop: '1rem',
                    }}
                >
                    <Icon className="text-xl">filter_list</Icon>
                    <Typography>{formatMessage({ id: 'Filter', defaultMessage: 'Filter'})}</Typography>
                </Fab>}

                {/* {isMobile && askToSearch && <Fab
                    className="bg-white text-base hover:bg-white focus:bg-white"
                    onClick={resumeSearchOnChange}
                    size="medium"
                    variant="extended"
                    style={{
                        bottom: '32px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        margin: 0,
                        position: "absolute",
                    }}
                >
                    <Typography variant="overline" className="text-xs">{formatMessage({ id: 'Search this area', defaultMessage: 'Search this area'})}</Typography>
                </Fab>} */}
            </div>

        </div>
    )
}

export default GoogleMap
